module.exports = __webpack_public_path__ + "images/sick.svg?39554e599cbfc638b7f00edc824ba140";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sick.svg
// module id = EhEw
// module chunks = 0